import { Divider, InputAdornment, Typography } from "@mui/material"
import { SearchOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"
import { useState } from "react"

import { FilterCheckbox } from "@/components/common/Filters"
import { AerosTextField } from "@/components/UiKit"
import type { Option } from "@/types/form-fields"

interface ProductInventoryProductClassFilterProps {
  control: any
  values: string[]
  options: Option<string>[]
  onChange: (values: string[]) => void
}

export const ProductInventoryProductClassFilter: FC<ProductInventoryProductClassFilterProps> = ({
  control,
  values,
  options,
  onChange,
}) => {
  const [query, setQuery] = useState("")

  const filteredOptions = options.filter((option) => option.label.toLowerCase().includes(query.toLowerCase()))

  return (
    <div className='flex min-h-0 flex-1 flex-col' data-testid='product-inventory.product-class-filter'>
      <Typography variant='subtitle1' fontWeight={700} className='px-4 py-1.5 text-gray-700'>
        Category/Class
      </Typography>
      <Divider className='mb-4' />
      <div className='flex min-h-0 flex-1 flex-col gap-4 px-4'>
        <AerosTextField
          size='small'
          placeholder='Search...'
          value={query}
          onChange={setQuery}
          data-testid='product-inventory.product-class-filter.search-field'
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position='start'>
                  <SearchOutlined className='text-gray-600' />
                </InputAdornment>
              ),
            },
          }}
        />
        <div className='flex flex-1 flex-col overflow-y-auto'>
          {filteredOptions.map((option) => (
            <FilterCheckbox
              key={option.value}
              control={control}
              name='productClassIds'
              value={option.value}
              values={values}
              label={option.label}
              onFilterChange={onChange}
              data-testid={`product-inventory.product-class-filter.option-${option.value}`}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
